import MainProps from "./types";

import "./styles.scss";

const Main = ({ children }: MainProps): JSX.Element => <>{children}</>;

export default Main;
